/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconLandingPartnerSliderArrow.vue?vue&type=template&id=d34e8ed2"
import script from "./IconLandingPartnerSliderArrow.vue?vue&type=script&lang=js"
export * from "./IconLandingPartnerSliderArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports